<script lang="ts">
	import { _ } from 'svelte-i18n';
	import { page } from '$app/stores';
	import FastBtn from '$lib/component/fast-btn.svelte';
	import Footer from '$lib/component/footer.svelte';
	import Navbar from '$lib/component/navbar.svelte';
	import Partner from '$lib/component/partner.svelte';
	import { initHeroHomeSwiper } from '$lib/js/script.js';
	import { onMount } from 'svelte';
	import { goto } from '$app/navigation';

	import type { PageServerData } from './$types';
	export let data: PageServerData;
	import type { PageLoad } from './$types';

	const lang = $page.params.locale;

	let partner = data?.partner;
	let room = data?.room;
	let facilities = data?.facilities;
	let offer = data?.offer;
	let award = data?.award;
	let guestinfo = data?.guestinfo;

	onMount(() => {
		initHeroHomeSwiper();
	});
</script>

<svelte:head>
	<title>Home - Holiday Inn Resort Bali Nusa Dua</title>
	<link rel="canonical" href="https://balinusadua.holidayinnresorts.com/en/" />
</svelte:head>

<Navbar />

<FastBtn />

<section id="home">
	<div id="hero-banner" class="container-fluid p-0">
		<div class="w-100 h-100 p-md-0 p-0 position-relative">
			<div class="w-100 h-100">
				<video
					class="w-100 h-100 object-fit-cover"
					autoplay
					loop
					muted
					defaultMuted
					playsinline
					on:contextmenu|preventDefault
					preload="auto"
					id="heroVideo"
				>
					<source src="https://hollidayinn-nusadua.b-cdn.net/" type="video/mp4" />
					Your browser does not support HTML5 video.
				</video>
			</div>
			<div id="hero-text" class="position-absolute top-0 start-0 w-100 h-100">
				<div class="row g-0 w-100 h-100 justify-content-center align-items-center">
					<div class="col-md-6 text-center text-white p-3">
						<!-- <h1 class="ff-lola-bir display-3 mb-3">A Family Friendly <br /> Resort in Bali</h1> -->
						<!-- <p class="ff-r mb-0">
							<small
								>Discover your family’s perfect escape along the sun-kissed shores of Nusa Dua
								Beach. From stylish accommodations to endless fun for kids and relaxation for
								adults, our contemporary coastal retreat offers everything you need to create
								unforgettable memories in paradise. Welcome to your Bali sanctuary.</small
							>
						</p> -->
					</div>
				</div>
			</div>
		</div>
	</div>

	<div class="container-fluid py-md-5 py-5 px-0 home-welcome position-relative mb-md-5 mb-4">
		<div class="row g-0 justify-content-center align-items-center">
			<div
				class="col-md-4 offset-md-1 position-relative p-md-5 p-5 img-home-welcome order-2 order-md-1"
			>
				<div class="ratio-3x4">
					<img
						alt="Holiday Inn Resorts Nusa Dua"
						src="/img/img-home-1.webp"
						class="w-100 h-100 object-fit-cover position-relative z-3"
					/>
				</div>
			</div>
			<div class="col-md-6 px-md-5 px-3 mb-3 mb-md-0 text-center order-1 order-md-2">
				<p class="mb-0 main-color display-3 pe-md-3 ff-lola-bir mt-md-5 lh-2">
					Holiday Inn Resort <br /> Bali Nusa Dua
				</p>
				<p class="mb-md-4 mb-3 main-color fs-3 lh-base ff-lola-r">{$_('home_sub_1')}</p>
				<p class="line mb-md-4 mb-3 mx-auto"></p>
				<p class="ff-helvetica">
					{$_('home_desc_1')}
				</p>
			</div>
		</div>
	</div>

	<div class="container-fluid py-md-5 py-5 px-0">
		<div class="row g-0">
			<div class="col-md-5 px-md-5 px-3 mb-md-0 mb-4">
				<p class="mb-0 main-color display-3 pe-md-3 ff-lola-bir mt-md-5 lh-2">
					{@html $_('home_title_2')}
				</p>
				<p class="line mb-md-5 mb-4"></p>
				<p class="ff-helvetica mb-md-5 mb-4 lh-lg">
					{$_('home_desc_2')}
				</p>
				<div class="nav-slider-room d-flex align-items-center">
					<span
						class="btn btn-prev d-flex align-items-center justify-content-center me-3 rounded-circle"
						><svg
							xmlns="http://www.w3.org/2000/svg"
							width="32"
							height="32"
							fill="#000000"
							viewBox="0 0 256 256"
							><path
								d="M164.24,203.76a6,6,0,1,1-8.48,8.48l-80-80a6,6,0,0,1,0-8.48l80-80a6,6,0,0,1,8.48,8.48L88.49,128Z"
							></path></svg
						></span
					>
					<span class="btn btn-next d-flex align-items-center justify-content-center rounded-circle"
						><svg
							xmlns="http://www.w3.org/2000/svg"
							width="32"
							height="32"
							fill="#000000"
							viewBox="0 0 256 256"
							><path
								d="M180.24,132.24l-80,80a6,6,0,0,1-8.48-8.48L167.51,128,91.76,52.24a6,6,0,0,1,8.48-8.48l80,80A6,6,0,0,1,180.24,132.24Z"
							></path></svg
						></span
					>
				</div>
			</div>
			<div class="col-md-7">
				<div class="swiper slider-room">
					<div class="swiper-wrapper">
						{#each room as room}
							<div class="swiper-slide">
								<!-- desktop -->
								<div class="d-none d-md-block">
									<div class="swiper slider-img-room position-relative">
										<div class="swiper-wrapper">
											{#each room?.featured_images as img}
												<div class="swiper-slide">
													<div class="ratio-5x6 rounded-4">
														<img
															alt="Holiday Inn Resort Nusa Dua"
															src={img.path}
															class="w-100 h-100 object-fit-cover rounded-4"
														/>
													</div>
												</div>
											{/each}
										</div>

										<div
											class="nav-slider-img-room position-absolute top-0 start-0 w-100 h-100 rounded-4 d-flex align-items-end justify-content-between z-3 p-3"
										>
											<div class="m-1 position-relative text-white" style="width:13%">
												<div class="swiper-pagination"></div>
											</div>
											<div class="d-flex">
												<span
													class="btn btn-outline-light btn-prev d-flex align-items-center justify-content-center me-2"
													><svg
														xmlns="http://www.w3.org/2000/svg"
														width="32"
														height="32"
														fill="none"
														viewBox="0 0 256 256"
														><path
															d="M164.24,203.76a6,6,0,1,1-8.48,8.48l-80-80a6,6,0,0,1,0-8.48l80-80a6,6,0,0,1,8.48,8.48L88.49,128Z"
														></path></svg
													></span
												>
												<span
													class="btn btn-outline-light btn-next d-flex align-items-center justify-content-center"
													><svg
														xmlns="http://www.w3.org/2000/svg"
														width="32"
														height="32"
														fill="none"
														viewBox="0 0 256 256"
														><path
															d="M180.24,132.24l-80,80a6,6,0,0,1-8.48-8.48L167.51,128,91.76,52.24a6,6,0,0,1,8.48-8.48l80,80A6,6,0,0,1,180.24,132.24Z"
														></path></svg
													></span
												>
											</div>
										</div>
									</div>

									<div class="row g-0 mt-3">
										<div class="col-md-8">
											<p class="mb-3 main-color fs-4 ff-lola-bir lh-2">
												{room?.name}
											</p>
											<p class="mb-1 ff-helvetica">
												<img src="/img/icon/ruler-black.svg" class="me-1" alt="icon" />
												{room?.feature?.size}
											</p>
											<p class="mb-1 ff-helvetica">
												<img src="/img/icon/bed-black.svg" class="me-1" alt="icon" />
												{room?.feature?.bed}
											</p>
											<p class="mb-1 ff-helvetica">
												<img src="/img/icon/binoculars-black.svg" class="me-1" alt="icon" />
												{room?.feature?.view}
											</p>
										</div>
										<div class="col-md-4 text-end">
											<a
												href="/{lang}/rooms/{room.slug}"
												class="btn main-btn px-4 py-2 ff-helvetica d-none d-md-inline-block"
												>{$_('btn_view_details')}</a
											>
										</div>
									</div>
								</div>

								<!-- mobile -->
								<div class="d-block d-md-none px-3">
									<a data-sveltekit-reload href="/{lang}/rooms" class="text-decoration-none">
										<div class="ratio-5x6 rounded-4 position-relative">
											<img
												src={room.featured_images[0].path}
												alt="Holiday Inn Resort Nusa Dua"
												class="w-100 h-100 object-fit-cover rounded-4"
											/>

											<div
												class="position-absolute bottom-0 start-0 w-100 p-3 rounded-4 pt-5"
												style="background-image: linear-gradient(to top, rgba(0,0,0,0.7), rgba(0,0,0,0.5), rgba(0,0,0,0))"
											>
												<div class="row g-0">
													<div class="col-12 text-white">
														<p class="mb-0 fs-1 ff-lola-bir lh-2">
															{room?.name}
														</p>
														<p class="mb-1 ff-helvetica">
															<img src="/img/icon/ruler-white.svg" class="me-1" alt="icon" />
															{room?.feature?.size}
														</p>
														<p class="mb-1 ff-helvetica">
															<img src="/img/icon/bed-white.svg" class="me-1" alt="icon" />
															{room?.feature?.bed}
														</p>
														<p class="mb-1 ff-helvetica">
															<img src="/img/icon/binoculars-white.svg" class="me-1" alt="icon" />
															{room?.feature?.view}
														</p>
													</div>
												</div>
											</div>
										</div>
									</a>
								</div>
							</div>
						{/each}
					</div>
				</div>
			</div>
		</div>
	</div>

	<div class="container home-amenities py-md-5 py-4">
		<div class="row g-0 justify-content-center">
			<div class="col-md-10 text-center">
				<p class="mb-3 main-color display-3 pe-md-3 ff-lola-bir mt-md-5 lh-2">
					{$_('home_title_3')}
				</p>
				<p class="line mb-md-5 mb-4 mx-auto"></p>
			</div>
			<div class="col-md-10 row g-0">
				<div class="col-md-4 col-6 d-flex align-items-center p-3">
					<div class="icon p-2 me-2">
						<img src="/img/icon/baby-blue.svg" class="h-100" alt="icon" />
					</div>
					<span class="main-color ff-lola-bir fs-5 ms-1 lh-1"> {$_('fa_1')} </span>
				</div>
				<div class="col-md-4 col-6 d-flex align-items-center p-3">
					<div class="icon p-2 me-2">
						<img src="/img/icon/island-blue.svg" class="h-100" alt="icon" />
					</div>
					<span class="main-color ff-lola-bir fs-5 ms-1 lh-1"> {$_('fa_2')} </span>
				</div>
				<div class="col-md-4 col-6 d-flex align-items-center p-3">
					<div class="icon p-2 me-2">
						<img src="/img/icon/spray-bottle-blue.svg" class="h-100" alt="icon" />
					</div>
					<span class="main-color ff-lola-bir fs-5 ms-1 lh-1"> {$_('fa_3')} </span>
				</div>
				<div class="col-md-4 col-6 d-flex align-items-center p-3">
					<div class="icon p-2 me-2">
						<img src="/img/icon/barbell-blue.svg" class="h-100" alt="icon" />
					</div>
					<span class="main-color ff-lola-bir fs-5 ms-1 lh-1"> {$_('fa_4')} </span>
				</div>
				<div class="col-md-4 col-6 d-flex align-items-center p-3">
					<div class="icon p-2 me-2">
						<img src="/img/icon/cone-blue.svg" class="h-100" alt="icon" />
					</div>
					<span class="main-color ff-lola-bir fs-5 ms-1 lh-1"> {$_('fa_5')} </span>
				</div>
				<div class="col-md-4 col-6 d-flex align-items-center p-3">
					<div class="icon p-2 me-2">
						<img src="/img/icon/pool-blue.svg" class="h-100" alt="icon" />
					</div>
					<span class="main-color ff-lola-bir fs-5 ms-1 lh-1"> {$_('fa_6')} </span>
				</div>
				<div class="col-md-4 col-6 d-flex align-items-center p-3">
					<div class="icon p-2 me-2">
						<img src="/img/icon/fork-knife-blue.svg" class="h-100" alt="icon" />
					</div>
					<span class="main-color ff-lola-bir fs-5 ms-1 lh-1"> {$_('fa_7')} </span>
				</div>
				<div class="col-md-4 col-6 d-flex align-items-center p-3">
					<div class="icon p-2 me-2">
						<img src="/img/icon/lotus-blue.svg" class="h-100" alt="icon" />
					</div>
					<span class="main-color ff-lola-bir fs-5 ms-1 lh-1"> {$_('fa_8')} </span>
				</div>
				<div class="col-md-4 col-6 d-flex align-items-center p-3">
					<div class="icon p-2 me-2">
						<img src="/img/icon/cigarette-slash-blue.svg" class="h-100" alt="icon" />
					</div>
					<span class="main-color ff-lola-bir fs-5 ms-1 lh-1"> {$_('fa_9')} </span>
				</div>
				<div class="col-md-4 col-6 d-flex align-items-center p-3">
					<div class="icon p-2 me-2">
						<img src="/img/icon/wifi-blue.svg" class="h-100" alt="icon" />
					</div>
					<span class="main-color ff-lola-bir fs-5 ms-1 lh-1"> {$_('fa_10')} </span>
				</div>
				<div class="col-md-4 col-6 d-flex align-items-center p-3">
					<div class="icon p-2 me-2">
						<img src="/img/icon/bus-blue.svg" class="h-100" alt="icon" />
					</div>
					<span class="main-color ff-lola-bir fs-5 ms-1 lh-1"> {$_('fa_11')} </span>
				</div>
				<div class="col-md-4 col-6 d-flex align-items-center p-3">
					<div class="icon p-2 me-2">
						<img src="/img/icon/castle-blue.svg" class="h-100" alt="icon" />
					</div>
					<span class="main-color ff-lola-bir fs-5 ms-1 lh-1"> {$_('fa_12')} </span>
				</div>
				<div class="col-md-4 col-6 d-flex align-items-center p-3">
					<div class="icon p-2 me-2">
						<img src="/img/icon/game-blue.svg" class="h-100" alt="icon" />
					</div>
					<span class="main-color ff-lola-bir fs-5 ms-1 lh-1"> {$_('fa_13')} </span>
				</div>
				<div class="col-md-4 col-6 d-flex align-items-center p-3">
					<div class="icon p-2 me-2">
						<img src="/img/icon/beer-blue.svg" class="h-100" alt="icon" />
					</div>
					<span class="main-color ff-lola-bir fs-5 ms-1 lh-1"> {$_('fa_14')} </span>
				</div>
			</div>
		</div>
	</div>

	<div class="container-fluid px-0 py-md-5 py-4 px-md-0 px-3 home-highlight">
		<!-- Desktop -->
		<div class="row g-0 d-md-flex d-none">
			<div class="col-md-7 p-md-5 pe-md-0 bg-overlay position-relative">
				<div class="tab-content" id="myTabContent">
					{#each facilities as facility, index}
						<div
							class="tab-pane fade {index === 0 ? 'show active' : ''}"
							id="tab-{facility.slug}"
							role="tabpanel"
							aria-labelledby="tab-{facility.slug}"
							tabindex="0"
						>
							<div class="ratio ratio-16x9 position-relative">
								<img
									alt="Holiday Inn Resort Nusa Dua"
									src={facility.featured_images[0].path}
									class="w-100 h-100 object-fit-cover"
								/>
								<div
									class="text-section position-absolute top-0 start-0 w-100 h-100 row g-0 align-items-center p-md-4 p-3"
								>
									<div class="col-md-8">
										<p class="mb-2 text-white fs-1 pe-md-3 ff-lola-bir mb-md-2 lh-2">
											{facility.name}
										</p>
										<p class="line mb-md-3 mb-2 border-light"></p>
										<p class="mb-md-4 ff-helvetica text-white">
											{facility.excerpt}
										</p>
										<p class="ff-lola-r">
											<a data-sveltekit-reload href="/{lang}/facilities/{facility.slug}" class="btn btn-outline-light rounded-0"
												>{$_('btn_view_details')}</a
											>
										</p>
									</div>
								</div>
							</div>
						</div>
					{/each}
				</div>
			</div>
			<div
				class="col-md-5 align-self-stretch main-bg row g-0 justify-content-center align-items-center"
			>
				<div class="col-12 text-white p-md-5 p-3">
					<p class="mb-3 display-5 ff-lola-bir mb-md-5 lh-1">{$_('home_title_4')}</p>
					<div id="myTab" role="tablist" class="ff-lola-mr fs-4">
						{#each facilities as facility, index}
							<p>
								<a
									aria-label="tab-facility"
									class="nav-link {index === 0 ? 'active' : ''}"
									data-bs-toggle="tab"
									data-bs-target="#tab-{facility.slug}"
									role="tab"
									><span class="text-uppercase" style="cursor: pointer;">{facility.name}</span></a
								>
							</p>
						{/each}
					</div>
				</div>
			</div>
		</div>
		<!-- Mobile -->
		<div class="row g-0 d-flex d-md-none">
			<div class="col-12 mb-4">
				<p class="mb-2 main-color display-3 pe-md-3 ff-lola-bir lh-2 text-center">
					{$_('home_title_4')}
				</p>
				<p class="line mx-auto"></p>
			</div>
			<div class="col-12 row g-0">
				<div class="col-12 row g-0 align-items-center mb-3 main-color">
					<div class="col-1 nav-slider-highlight">
						<span class="btn-prev d-flex align-items-center justify-content-center"
							><svg
								xmlns="http://www.w3.org/2000/svg"
								width="32"
								height="32"
								fill="#451C70"
								viewBox="0 0 256 256"
								><path
									d="M164.24,203.76a6,6,0,1,1-8.48,8.48l-80-80a6,6,0,0,1,0-8.48l80-80a6,6,0,0,1,8.48,8.48L88.49,128Z"
								></path></svg
							></span
						>
					</div>
					<div class="col-10 px-4">
						<div class="swiper slider-highlight-title">
							<div class="swiper-wrapper">
								{#each facilities as facility, index}
									<div class="swiper-slide">
										<p class="ff-lola-bir fs-1 bg-white text-center mb-0">{facility.name}</p>
									</div>
								{/each}
							</div>
						</div>
					</div>
					<div class="col-1 nav-slider-highlight text-custom">
						<span class="btn-next d-flex align-items-center justify-content-center"
							><svg
								xmlns="http://www.w3.org/2000/svg"
								width="32"
								height="32"
								fill="#451C70"
								viewBox="0 0 256 256"
								><path
									d="M180.24,132.24l-80,80a6,6,0,0,1-8.48-8.48L167.51,128,91.76,52.24a6,6,0,0,1,8.48-8.48l80,80A6,6,0,0,1,180.24,132.24Z"
								></path></svg
							></span
						>
					</div>
				</div>
				<div class="col-12">
					<div class="swiper slider-highlight-img">
						<div class="swiper-wrapper">
							{#each facilities as facility, index}
								<div class="swiper-slide">
									<div class="ratio-3x4 rounded-4 position-relative">
										<img
											alt="Holiday Inn Resort Nusa Dua"
											src={facility.featured_images[0].path}
											class="w-100 h-100 object-fit-cover rounded-4"
										/>

										<div
											class="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-end justify-content-center text-img-highlight p-4 rounded-4"
										>
											<div class="text-center">
												<p class="mb-2 fs-1 text-white ff-lola-bir lh-2 text-center">
													{facility.name}
												</p>
												<p class="line mx-auto mb-2 border-light"></p>
												<p class="text-white mb-0">
													<small>{facility.excerpt}</small>
												</p>
											</div>
										</div>
									</div>
								</div>
							{/each}
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div class="container py-md-5 py-5 px-md-0 px-3">
		<div class="row g-0">
			<div class="col-md-12 mb-md-4 mb-4 row g-0 justify-content-between">
				<div class="col-md-6 mb-md-0 mb-3">
					<p class="mb-md-3 main-color display-3 ff-lola-bir lh-2">{$_('home_title_5')}</p>
					<p class="line mb-md-4 mb-3"></p>
					<p class="ff-helvetica mb-0 lh-lg">
						{$_('home_desc_5')}
					</p>
				</div>
				<div class="col-md-3 text-start text-md-end align-self-end">
					<div
						class="nav-slider-offers d-flex align-items-center justify-content-md-end justify-content-start"
					>
						<span
							class="btn btn-prev d-flex align-items-center justify-content-center me-3 rounded-circle"
							><svg
								xmlns="http://www.w3.org/2000/svg"
								width="32"
								height="32"
								fill="#000000"
								viewBox="0 0 256 256"
								><path
									d="M164.24,203.76a6,6,0,1,1-8.48,8.48l-80-80a6,6,0,0,1,0-8.48l80-80a6,6,0,0,1,8.48,8.48L88.49,128Z"
								></path></svg
							></span
						>
						<span
							class="btn btn-next d-flex align-items-center justify-content-center rounded-circle"
							><svg
								xmlns="http://www.w3.org/2000/svg"
								width="32"
								height="32"
								fill="#000000"
								viewBox="0 0 256 256"
								><path
									d="M180.24,132.24l-80,80a6,6,0,0,1-8.48-8.48L167.51,128,91.76,52.24a6,6,0,0,1,8.48-8.48l80,80A6,6,0,0,1,180.24,132.24Z"
								></path></svg
							></span
						>
					</div>
				</div>
			</div>
			<div class="col-md-12">
				<div class="swiper slider-offers">
					<div class="swiper-wrapper">
						{#each offer as offer}
							<div class="swiper-slide">
								<div class="ratio ratio-1x1 mb-2 img-offers d-none d-md-block">
									<img
										alt="Holiday Inn Resort Nusa Dua"
										src={offer?.featured_images[0]?.path}
										class="w-100 h-100 object-fit-cover"
									/>
								</div>
								<div class="ratio ratio-1x1 rounded-4 mb-2 img-offers d-block d-md-none">
									<img
										alt="Holiday Inn Resort Nusa Dua"
										src={offer?.featured_images[0]?.path}
										class="w-100 h-100 object-fit-cover rounded-4"
									/>
								</div>
								<p class="ff-lola-mr fs-4 text-center text-md-start mb-md-0 mb-2">
									<a
										data-sveltekit-reload
										href="/{lang}/offers#{offer.slug}"
										class="text-decoration-none main-color">{offer?.name}</a
									>
								</p>
								<p class="d-inline-block d-md-none ff-helvetica w-100 text-center">
									<a
										data-sveltekit-reload
										href="/{lang}/offers#{offer.slug}"
										class="btn main-btn rounded-3 px-4 py-2">{$_('btn_view_details')}</a
									>
								</p>
							</div>
						{/each}
					</div>
				</div>
			</div>
		</div>
	</div>
</section>

<Partner {partner} />

<Footer {award} />

<style>
	#hero-text {
		background-color: rgba(0, 0, 0, 0.3);
	}
	.home-welcome {
		background-image: linear-gradient(
				to top,
				rgba(255, 255, 255, 1),
				rgba(255, 255, 255, 0.85),
				rgba(255, 255, 255, 0.8)
			),
			url('/img/bg-home-1.jpg');
		background-position: center;
		background-size: cover;
	}
	.home-welcome:before {
		content: '';
		position: absolute;
		bottom: 0;
		left: 0;
		width: 20%;
		height: 50%;
		background-color: #9bc5b7;
	}
	.home-welcome:after {
		content: '';
		position: absolute;
		top: 5%;
		right: 55%;
		width: 10%;
		height: 50%;
		background-color: #9bc5b7;
	}
	.line {
		border-bottom: 2px solid #451C70;
		width: 25%;
	}
	.nav-slider-room .btn-next svg,
	.nav-slider-room .btn-prev svg {
		fill: #451C70;
		transition: 0.3s all;
	}
	.nav-slider-room .btn-next:hover svg,
	.nav-slider-room .btn-prev:hover svg {
		fill: white;
		transition: 0.3s all;
	}
	.nav-slider-img-room .btn-prev svg,
	.nav-slider-img-room .btn-next svg {
		fill: white;
		transition: 0.3s all;
	}
	.nav-slider-img-room .btn-prev:hover svg,
	.nav-slider-img-room .btn-next:hover svg {
		fill: black;
		transition: 0.3s all;
	}
	.nav-slider-offers .btn-next svg,
	.nav-slider-offers .btn-prev svg {
		fill: #451C70;
		transition: 0.3s all;
	}
	.nav-slider-offers .btn-next:hover svg,
	.nav-slider-offers .btn-prev:hover svg {
		fill: white;
		transition: 0.3s all;
	}
	.home-amenities .icon {
		background-color: #ebe5ef;
		color: #451C70;
		border-radius: 100%;
		width: 40px;
		height: 40px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.home-highlight .bg-overlay:after {
		content: '';
		position: absolute;
		top: 0;
		right: -2px;
		height: 100%;
		width: 20%;
		background-color: #451C70;
		z-index: -1;
	}
	.home-highlight .nav-link.active {
		position: relative; /* Penting untuk pseudo-element */
	}

	.home-highlight .nav-link.active::before {
		content: '';
		position: absolute;
		top: 50%; /* Posisi garis vertikal di tengah */
		left: 0; /* Mulai dari kiri */
		width: 60px; /* Lebar garis */
		height: 2px; /* Tinggi garis */
		transform: translateY(-50%); /* Agar sejajar dengan teks */
		background-color: white; /* Warna garis */
		border-radius: 1px; /* Opsional: Melengkungkan sedikit sudut */
		transition: all 0.3s ease; /* Animasi untuk garis */
	}

	.home-highlight .nav-link.active span {
		display: inline-block; /* Penting agar bisa bergeser */
		margin-left: 70px; /* Geser ke kanan */
		transition: margin-left 0.3s ease; /* Animasi untuk pergeseran */
	}

	.home-highlight .nav-link:not(.active) span {
		margin-left: 0; /* Kembalikan ke posisi awal jika tidak aktif */
		transition: margin-left 0.3s ease; /* Pastikan ada transisi juga */
	}

	.home-highlight .nav-link:not(.active)::before {
		width: 0; /* Garis menghilang saat tidak aktif */
		transition: all 0.3s ease; /* Pastikan transisi halus untuk garis */
	}
	.home-highlight .text-section {
		background-image: linear-gradient(
			to right,
			rgba(0, 0, 0, 0.7),
			rgba(0, 0, 0, 0.5),
			rgba(0, 0, 0, 0)
		);
	}
	@media (max-width: 600px) {
		#hero-banner {
			width: 100%;
			height: 100dvh !important;
		}
		#hero-text .display-3 {
			font-size: 26px !important;
		}
		.home-welcome:before {
			content: unset;
		}
		.home-welcome:after {
			content: unset;
		}
		.img-home-welcome:before {
			content: '';
			position: absolute;
			bottom: 0;
			left: 0;
			width: 30%;
			height: 50%;
			background-color: #9bc5b7;
		}
		.img-home-welcome:after {
			content: '';
			position: absolute;
			top: 5%;
			right: 0%;
			width: 30%;
			height: 50%;
			background-color: #9bc5b7;
		}
		.home-highlight {
			position: relative;
		}
		.home-highlight::after {
			content: '';
			position: absolute;
			bottom: 0;
			left: 0;
			width: 100%;
			height: 40%;
			background-color: #9bc5b7;
		}
		.home-highlight .nav-slider-highlight span {
			font-size: 28px;
		}
		.home-highlight .slider-highlight-img .text-img-highlight {
			background-image: linear-gradient(
				to top,
				rgba(0, 0, 0, 0.8),
				rgba(0, 0, 0, 0.5),
				rgba(0, 0, 0, 0)
			);
		}
	}
</style>
